export const Colors = {
  grey: "#4f4f4f",
  plat: "#E7E5DF",
  pink: "#cb8589",
  blue: "#7298D7",
  slate: "#2A2A2A",
};
